import {
  Translation,
} from '@o3r/localization';

export interface CustomBackToMmbPresTranslation extends Translation {
  /** exit link button label. */
  exitLinkLabel: string;

  /** exit link button url. */
  fallbackExitLinkUrl: string;

  /** Survey section title. */
  surveyTitle: string;

  /** Survey section text. */
  surveyText: string;

  /** Survey link button label. */
  surveyLinkLabel: string;

  /** Survey link button url. */
  surveyLinkUrl: string;
}

export const customTranslations: CustomBackToMmbPresTranslation = {
  exitLinkLabel: 'custom-back-to-mmb-pres.exitLinkLabel',
  exitLinkLabelRefund: 'custom-back-to-mmb-pres.exitLinkLabelRefund',
  fallbackExitLinkUrl: 'custom-back-to-mmb-pres.fallbackExitLinkUrl',
  surveyTitle: 'custom-back-to-mmb-pres.surveyTitle',
  surveyText: 'custom-back-to-mmb-pres.surveyText',
  surveyLinkLabel: 'custom-back-to-mmb-pres.surveyLinkLabel',
  surveyLinkUrl: 'custom-back-to-mmb-pres.surveyLinkUrl'
};
